import { render, staticRenderFns } from "./shipping-address.vue?vue&type=template&id=0e23d240&"
import script from "./shipping-address.vue?vue&type=script&lang=js&"
export * from "./shipping-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports